import React, { useState } from 'react';
import '../unAuth/Contact.css';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills } from '@fortawesome/free-solid-svg-icons';
import { Navigate, useNavigate } from 'react-router-dom';

const Privacy = () => {

  return (
    <div className="contact-background">
      <div className="contact-container">
        <h1 className="contact-title">Privacy Policy </h1>
            <div className="privacy-content">

<p>Effective Date: 07-06-2025</p>
<p>ClinicSync ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our software and services.</p>

<p>1. Information We Collect</p>
<p>
We may collect and store the following information:

Personal Information: Name, email address, phone number, and clinic name.

Clinic Data: Patient records, appointments, prescriptions, and receipts.

Usage Data: Device info, IP address, browser type, access times.
</p>
<p>2. How We Use Your Information</p>
<p>
We use the collected data to:

Provide and maintain our services.

Manage user accounts and authentication.

Improve our platform and customer support.

Comply with legal obligations.
</p>
<p>3. Sharing Your Information</p>
<p>
We do not sell or rent your personal data. We may share information:

With trusted third-party service providers (e.g., Firebase).

If required by law, regulation, or legal process.
</p>
<p>4. Data Security</p>
<p>
We use secure, encrypted systems (like Firebase) to protect your data. However, no method is 100% secure, so we cannot guarantee absolute security.
</p>
<p>5. Your Rights</p>
<p>
You have the right to:

Access your data.

Request corrections or deletions.

Withdraw consent at any time.

To exercise these rights, contact us at: info@osiqsolutions.com
</p>
<p>6. Third-Party Links</p>
<p>
Our app may contain links to third-party sites. We are not responsible for their privacy practices.
</p>
<p>7. Changes to This Policy</p>
<p>
We may update this Privacy Policy. Any changes will be posted on this page with an updated "Effective Date".
</p>
<p>8. Contact Us</p>
<p>
For questions or concerns, contact:
📧 Email: info@osiqsolutions.com
📍 Address: OSIQ SOLUTIONS, Hyderabad, India
</p>

            </div>
      </div>
    </div>
  );
};

export default Privacy;